import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getOrderToShipTime = {
  name: "getOrderToShipTime" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
